export default "Les certificats d'économies d'énergie (CEE) en copropriété permettent de financer isolation, chaufferie collective et ventilation. Calculez les primes auxquelles votre immeuble est éligible.";
